import { createKeyFactory } from '@clouway/query'

export const serviceAccountsKeys = createKeyFactory('serviceAccounts')

export const serviceAccountsListKey = () => serviceAccountsKeys.list()

// Access-tab keys live under their own namespace, not nested under
// `serviceAccounts` — a rename/delete invalidating serviceAccountsKeys.all()
// (prefix `['serviceAccounts']`) would otherwise also refetch these, even
// though they don't depend on the account list. Mirrors the users feature's
// `accessKeys` split (see features/users/keyFactory.ts).
export const serviceAccountAccessKeys = createKeyFactory('serviceAccountAccess')

export const serviceAccountRoleAssignmentsKey = (id: string) => serviceAccountAccessKeys.custom('roleAssignments', id)

export const serviceAccountAccessPreviewKey = (id: string, product: string) =>
  serviceAccountAccessKeys.custom('accessPreview', id, product)

export const serviceAccountAllowedScopesKey = (id: string) => serviceAccountAccessKeys.custom('allowedScopes', id)
